window.WOODStorage = (() => {

  const historyStack = [];

  function getEls() {
    return window.els || {};
  }

  /* =========================
     SAVE
  ========================= */

  function save() {

    const els = getEls();

    try {

      const extraTextLayers = [];

      document
        .querySelectorAll('.draggable-text[data-extra="true"]')
        .forEach(el => {

          extraTextLayers.push({
            text: el.textContent,
            top: el.style.top,
            left: el.style.left,
            fontSize: el.style.fontSize,
            color: el.style.color,
            font: el.style.fontFamily
          });

        });

      const activeSwatch =
        document.querySelector(".color-swatch.active");

      const design = {

        text:
          els.textInput?.value || "",

        size:
          els.sizeSelector?.value || "",

        wood:
          els.woodType?.value || "",

        layers:
          els.layerSelector?.value || "",

        stain:
          els.stainSelector?.value || "",

        shape:
          els.shapeSelector?.value || "",

        textStyle:
          els.textStyle?.value || "",

        rush:
          els.rushOrder?.value || "",

        detail:
          els.detailToggle?.checked || false,

        textSize:
          els.textSizeSlider?.value || "",

        font:
          els.previewText?.style.fontFamily || "",

        color:
          els.previewText?.style.color || "",

        textPosition: {
          top:
            els.previewText?.style.top || "",
          left:
            els.previewText?.style.left || ""
        },

        imagePosition: {
  top:
    els.imageWrapper?.style.top || "",
  left:
    els.imageWrapper?.style.left || ""
},

imageSize:
  els.liveImage?.style.width || "150px",

swatch:
  activeSwatch?.dataset.color || "",

        extraTextLayers
      };

      if (
        els.liveImage?.src &&
        els.liveImage.src.startsWith("data:image")
      ) {

        design.image =
          els.liveImage.src;

      }

      historyStack.push(
        JSON.stringify(design)
      );

      if (historyStack.length > 30) {
        historyStack.shift();
      }

      localStorage.setItem(
        "woodDesign",
        JSON.stringify(design)
      );

      console.log("Design saved");

    } catch (err) {

      console.error(
        "Save failed",
        err
      );

    }

  }

  /* =========================
     LOAD
  ========================= */

  function load() {

    const els = getEls();

    let saved = null;

    try {

      saved = JSON.parse(
        localStorage.getItem("woodDesign")
      );

    } catch (e) {

      console.warn("Invalid saved design");

    }

    if (!saved) return;

    /* BASIC */

    if (els.textInput) {
      els.textInput.value =
        saved.text || "";
    }

    if (els.sizeSelector) {
      els.sizeSelector.value =
        saved.size || "";
    }

    if (els.woodType) {
      els.woodType.value =
        saved.wood || "";
    }

    if (els.layerSelector) {
      els.layerSelector.value =
        saved.layers || "";
    }

    if (els.stainSelector) {
      els.stainSelector.value =
        saved.stain || "";
    }

    if (els.shapeSelector) {
      els.shapeSelector.value =
        saved.shape || "";
    }

    if (els.textStyle) {
      els.textStyle.value =
        saved.textStyle || "";
    }

    if (els.rushOrder) {
      els.rushOrder.value =
        saved.rush || "";
    }

    if (els.detailToggle) {
      els.detailToggle.checked =
        saved.detail || false;
    }

    /* MAIN TEXT */

    if (els.previewText) {

      els.previewText.textContent =
        saved.text || "Your Text";

      els.previewText.style.fontFamily =
        saved.font || "";

      els.previewText.style.color =
        saved.color || "#000";

      els.previewText.style.fontSize =
        (saved.textSize || 40) + "px";

      els.previewText.style.top =
        saved.textPosition?.top || "120px";

      els.previewText.style.left =
        saved.textPosition?.left || "120px";

    }

    /* IMAGE */

    if (
      saved.image &&
      els.liveImage
    ) {

      els.liveImage.src =
        saved.image;

      els.imageWrapper.style.display =
        "block";

      els.liveImage.style.display =
        "block";

      els.imageWrapper.style.top =
  saved.imagePosition?.top || "120px";

els.imageWrapper.style.left =
  saved.imagePosition?.left || "120px";

if (saved.imageSize) {

  els.liveImage.style.width =
    saved.imageSize;

}

if (
  saved.imageSize &&
  els.imageSizeSlider
) {

  els.imageSizeSlider.value =
      parseInt(saved.imageSize);
  }

} // ← MISSING CLOSING BRACE

/* SWATCH */

if (saved.swatch) {

      document
        .querySelectorAll(".color-swatch")
        .forEach(s => {

          s.classList.remove("active");

          if (
            s.dataset.color === saved.swatch
          ) {

            s.classList.add("active");

          }

        });

    }

    /* EXTRA TEXT */

    document
      .querySelectorAll(
        '.draggable-text[data-extra="true"]'
      )
      .forEach(el => el.remove());

    if (saved.extraTextLayers?.length) {

      saved.extraTextLayers.forEach(layer => {

        const newText =
          document.createElement("div");

        newText.className =
          "draggable-text";

        newText.dataset.extra = "true";

        newText.textContent =
          layer.text;

        newText.style.position =
          "absolute";

        newText.style.top =
          layer.top;

        newText.style.left =
          layer.left;

        newText.style.fontSize =
          layer.fontSize;

        newText.style.color =
          layer.color;

        newText.style.fontFamily =
          layer.font;

        newText.style.cursor =
          "move";

        newText.style.zIndex =
          "20";

        if (els.addonLayer) {
  els.addonLayer.appendChild(newText);
}
        window.WOOD_DRAG?.enable?.(
  newText,
  els.preview
);

        window.attachTextLayerEvents?.(
          newText
        );

      });

    }

    /* REFRESH */

    window.updateShape?.();
window.updateStain?.();
window.updateTextStyle?.();

    window.WOODPricing?.updatePrice?.();

  }

  /* =========================
     UNDO
  ========================= */

  function undo() {

    if (historyStack.length < 2) return;

    historyStack.pop();

    const previous =
      JSON.parse(
        historyStack[
          historyStack.length - 1
        ]
      );

    localStorage.setItem(
      "woodDesign",
      JSON.stringify(previous)
    );

    load();

  }

  return {
    save,
    load,
    undo,
    historyStack
  };

})();